export default {

    NoteRows: 'Note Row|Note Rows',
};
